import { isMobile } from "react-device-detect";
import BreadcrumbComponent, {
  PAGE_BREADCRUMB,
} from "src/components/breadcrumb";
import HotelRevervationSuccessComponent from "../hotel-reservation-input/components/success";
import "./index.scss";

interface IProps {
  isResale: boolean;
}

function ReservationSuccessComponent({ isResale }: IProps) {
  const searchParams = new URLSearchParams(window.location.search);
  const reservationId = searchParams.get("number_no");

  const renderBreadcrumbs = () => {
    if (isResale) {
      return PAGE_BREADCRUMB["resale_reservation_3"];
    }

    return PAGE_BREADCRUMB["hotel_reservation_3"];
  };

  return (
    <div className="ReservationSuccessStyle">
      <div
        style={
          isMobile
            ? { paddingTop: "32px", paddingLeft: 16 }
            : { paddingLeft: "17%" }
        }
      >
        <div className="nafutel-layout-header">
          <BreadcrumbComponent page={renderBreadcrumbs()} />
        </div>
      </div>

      <HotelRevervationSuccessComponent
        isResale={isResale}
        data={reservationId}
      />
    </div>
  );
}

export default ReservationSuccessComponent;
